var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "node-view-wrapper",
    {
      staticClass: "sezar-parameter-validated-attribute",
      class: { active: _vm.active },
      attrs: { contenteditable: false },
    },
    [
      _c(
        "a-popover",
        {
          attrs: {
            trigger: "click",
            placement: "left",
            overlayClassName: "no-padding",
          },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "sezar-parameter-validated-attribute-popover",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("ParameterValidationForm", {
                attrs: {
                  "attribute-name": _vm.node.attrs.attributeName,
                  "validation-type": _vm.node.attrs.validationType,
                  "on-changed": _vm.onChanged,
                  "on-cancel": function () {
                    return (_vm.active = false)
                  },
                  omit: _vm.getOmitValidation(),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "pop-content",
              on: {
                click: function ($event) {
                  _vm.active = true
                },
              },
            },
            [
              _c("AttributeIconPreview", {
                attrs: { attribute: _vm.node.attrs.attributeName },
              }),
              _vm._v(
                "\n            " +
                  _vm._s(
                    ("" + _vm.node.attrs.attributeName).startsWith("akinon_") ||
                      _vm.Attributes.includes(_vm.node.attrs.attributeName)
                      ? _vm.$t("chatbotv2.attr." + _vm.node.attrs.attributeName)
                      : _vm.Entities.includes(_vm.node.attrs.attributeName)
                      ? _vm.$t("chatbotv2." + _vm.node.attrs.attributeName)
                      : _vm.node.attrs.attributeName
                  ) +
                  "\n        "
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }